import { axios, def, handleError, handleResponse } from './internal';

function AdminPostVector(postId, setData) {
    axios
        .post('/api/admin_post_vector', { postId })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    setData(res.data.data);
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { AdminPostVector };
